import React from 'react';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import propTypes from 'prop-types';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { RANGE_GTM_TRACKING_VALUES } from '../../../../../range/ui/constants/analytics.js';

export function NextSteps(props) {

  const { 
    block,
    text, 
    buttonOne, 
    buttonTwo,
    modelName
  } = props;

  if (buttonOne.trackingId) {
    buttonOne.trackingProps = {
      gtmName: CORE_GTM_TRACKING_VALUES.name.componentEvent,
      gtmComponentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      gtmComponentName: RANGE_GTM_TRACKING_VALUES.componentName.modelRange,
      gtmLabel: RANGE_GTM_TRACKING_VALUES.label[buttonOne.trackingId] + '-' + modelName,
      gtmAction: CORE_GTM_TRACKING_VALUES.action.clickCta
    }
  }

  if (buttonTwo.trackingId) {
    buttonTwo.trackingProps = {
      gtmName: CORE_GTM_TRACKING_VALUES.name.componentEvent,
      gtmComponentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      gtmComponentName: RANGE_GTM_TRACKING_VALUES.componentName.modelRange,
      gtmLabel: RANGE_GTM_TRACKING_VALUES.label[buttonTwo.trackingId] + '-' + modelName,
      gtmAction: CORE_GTM_TRACKING_VALUES.action.clickCta
    }
  }

  return (
    <div className={`${block}__next-steps col-12 col-xl-10`}>
      { text && <div className={`${block}__next-steps-text caveat`}>{text}</div> }
      <div className={`${block}__next-steps-buttons-container`}>
        { buttonOne.text && <Button type={buttonOne.type} label={buttonOne.text} href={buttonOne.href} {...buttonOne.trackingProps} /> }
        { buttonTwo.text && <Button type={buttonTwo.type} label={buttonTwo.text} href={buttonTwo.href} {...buttonTwo.trackingProps} /> }
      </div>
    </div>
  )
};

NextSteps.propTypes = {
  buttonOne: propTypes.object,
  buttonTwo: propTypes.object,
  text: propTypes.string,
  block: propTypes.string,
  modelName: propTypes.string,
};
